<div class="component-wrapper">
      <button class="add-document-btn" (click)="selectDocuments()"><img class="icon-add-doc" src="assets/icons-white/add.svg" alt=""></button>
</div>
